/* eslint-disable no-undef */
import { LitElement, html, css } from 'lit'
import { ifDefined } from 'lit/directives/if-defined.js'
import { unsafeHTML } from 'lit/directives/unsafe-html.js'
import { shopifyCart } from '../../api/cart'
import { centsToDollars, resizeImageSrc, unescapeStr, getProduct } from '../../lib/utils'
import { get } from '../../lib/ajax'
import $ from 'quantdom'

export class CartDrawer extends LitElement {
  static styles = [
    css`
      :host {
        width: 100%;
        height: 100%;
        z-index: 1000001;
      }

      * {
        font-family: ABC Oracle, sans-serif;
      }

      h3.cart-drawer_title {
        font-size: 16px;
        font-weight: 400;
        line-height: 16px;
        letter-spacing: 0em;
        text-align: left;
        margin: 0;
      }

      button:hover {
        cursor: pointer;
      }

      .relative {
        position: relative;
      }

      .flex {
        display: flex;
      }

      .hidden {
        display: none !important;
      }

      .flex-col {
        flex-direction: column;
      }

      .justify-between {
        justify-content: space-between;
      }

      .items-center {
        align-items: center;
      }

      .flex-1 {
        flex: 1 1 0%;
      }

      .font-bold {
        font-weight: 400;
      }

      .margin-t-xs {
        margin-top: 8px;
      }

      .margin-t-sm {
        margin-top: 10px;
      }

      .mt-3 {
        margin-top: 12px;
      }

      .mt-5 {
        margin-top: 20px;
      }

      .margin-b-xs {
        margin-bottom: 3px;
      }

      .text-center {
        text-align: center;
      }

      header {
        padding: 20px 20px 0;
      }

      .empty-cart .empty-cart_details button {
        font-size: 14px;
      }

      .cart-drawer_header-details {
        -webkit-box-shadow: 0px 0px 10px 0px #0000001a;
        -moz-box-shadow: 0px 0px 10px 0px #0000001a;
        box-shadow: 0px 0px 10px 0px #0000001a;
        display: flex;
        align-items: flex-end;
        padding: 6px 20px;
        column-gap: 6px;
        position: relative;
        z-index: 1;
      }

      .cart-drawer_header-value-props {
        display: flex;
        column-gap: 8px;
        justify-content: center;
        padding-top: 8px;
        padding-bottom: 8px;
        border-bottom: 1px solid #0a0a0a;
        font-size: 12px;
        font-weight: 400;
        line-height: 12px;
        letter-spacing: 0px;
        text-align: center;
      }

      .gift-with-purchase_one-time-header {
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 8px;
        padding: 6px 20px;
        background-color: #97cff6;
        color: #0a0a0a;
        box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.05);
        text-align: center;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 120%;
      }

      @media (max-width: 430px) {
        header {
          padding: 20px 0 0 0;
        }
      }

      .cart-drawer_cart-count {
        font-size: 16px;
        font-weight: 400;
        margin: 0;
        position: relative;
        top: 1px;
      }

      .bundle {
        margin: 8px 0 0 0;
        font-size: 12px;
        font-weight: bold;
      }

      .cart-drawer {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 100%;
        height: 100%;
      }

      .cart-item .right {
        width: 100%;
      }

      .cart-item-delete {
        min-width: 116px;
        width: 100%;
        scroll-snap-align: end;
      }

      .cart-item-subscription {
        margin-bottom: 6px;
        font-size: 10px;
        color: #978f90;
        display: flex;
        align-items: center;
      }

      @media (min-width: 431px) {
        .cart-item {
          width: 100%;
        }
      }

      .cart-item .cart-item_border {
        padding: 8px;
        gap: 8px;
      }

      .cart-item {
        background-color: white;
        list-style-type: none;
        border-radius: 2px;
        box-shadow: 0px 0px 10px 0px #0000001a;
      }

      .cart-drawer .cart-item:not(:last-child) .cart-item_border {
        border-bottom: 1px solid #eeeceb;
      }
      /* Main Cart Page Styles */
      .cart-drawer[main='true'] .cart-item {
        width: 100%;
      }

      .cart-drawer[main='true'] .cart-item-delete {
        display: none;
      }

      .cart-item > .right {
        margin-left: 10px;
        flex: 1;
        display: flex;
        flex-direction: column;
      }

      .cart-item_image-container {
        position: relative;
      }

      .cart-item img.cart-item_image {
        height: 100%;
        object-fit: cover;
        max-width: 80px;
        margin: 0 auto;
        border-radius: 2px;
      }

      .cart-item_plan-count {
        font-size: 10px;
        line-height: 10px;
        letter-spacing: 0em;
        position: absolute;
        background-color: #fff;
        top: 4px;
        left: 4px;
        border-radius: 6px;
      }

      .cart-drawer {
        font-size: 14px;
      }

      .cart-drawer .cart-drawer_products-container {
        display: flex;
        flex-direction: column;
        min-height: 0;
        height: 100%;
        background-color: #f4f4f2;
        overflow-y: scroll;
      }

      .cart-drawer .cart-drawer_products-line-container {
        display: flex;
        flex-direction: column;
        height: 100%;
      }

      .cart-drawer .cart-drawer_products {
        padding: 0 20px 20px 20px;
        list-style-type: none;
        margin: 0;
        background: #fff;
      }

      .cart-drawer_bottom {
        padding: 8px 20px 16px;
        background: #fff;
        border-top: 1px solid #dcdcda;
      }

      .cart-drawer_bottom-subtotal {
        font-size: 18px;
        font-weight: 400;
      }

      .cart-drawer_bottom-savings {
        padding: 6px 8px 6px 8px;
        border-radius: 2px;
        gap: 8px;
        color: #fff;
        background-color: #0a0a0a;
        font-size: 12px;
        line-height: 12px;
        font-weight: 400;
      }

      .cart-drawer_bottom-total {
        display: flex;
        align-items: center;
        column-gap: 12px;
      }

      .cart-drawer_bottom ul {
        padding-inline-start: 0;
      }

      button.close-btn {
        background: none;
        border: none;
        cursor: pointer;
        position: absolute;
        right: 0px;
        top: 5px;
      }

      input::-webkit-outer-spin-button,
      input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }

      /* Firefox */
      input[type='number'] {
        -moz-appearance: textfield;
      }

      .quantity-selector {
        width: 75px;
        border: 1px solid #626261;
        border-radius: 2px;
      }

      .quantity-selector input,
      .quantity-selector button {
        background: none;
        border: none;
        text-align: center;
        padding: 0;
      }

      .quantity-selector button {
        justify-content: center;
        display: flex;
        align-items: center;
      }

      button.remove-btn {
        border: solid 1px #626261;
        border-radius: 2px;
        background-color: #fff;
        line-height: 1;
        padding: 0 10px;
        margin-left: 5px;
        height: 27px;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .remove-btn_icon {
        width: 9px;
        color: #627073;
      }

      .quantity-selector > button,
      .quantity-selector > input[type='number']:disabled,
      button.remove-btn {
        color: #626261;
        -webkit-text-fill-color: #626261;
        opacity: 1; /* required on iOS */
        width: 100%;
        max-width: 30px;
        font-size: 14px;
      }

      .quantity-selector:has(button[aria-disabled='true']),
      button.remove-btn[aria-disabled='true'] {
        display: none;
      }

      .left {
        display: flex;
        flex-direction: column;
        gap: 10px;
      }

      .loading-container {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        background: white;
      }

      .cart-drawer_container {
        display: flex;
        flex-direction: column;
        padding: 12px 20px;
        gap: 8px;
      }

      .cart-drawer[loading='true'] .cart-drawer_bucket-container,
      .cart-drawer[loading='true'] .cart-drawer_container,
      .cart-drawer[loading='true'] .cart-drawer_upsells {
        display: none;
      }

      .cart-drawer[loading='false'] .loading-container {
        display: none;
      }

      h5 {
        margin: 0;
        font-size: 16px;
      }

      .order-total {
        font-weight: 400;
        font-size: 14px;
      }

      .empty-cart {
        display: flex;
        flex-direction: column;
      }

      .empty-cart_details {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        max-width: 330px;
        margin: 0 auto 50% auto;
      }

      a {
        text-decoration: none;
      }

      .empty-cart_text {
        text-align: center;
        font-size: 16px;
        margin-top: 0px;
        margin-bottom: 0px;
        line-height: 1.5;
        white-space: pre;
        padding: 25px 15px;
        background-color: #fff;
      }

      .empty-cart_image {
        height: auto;
        width: 100%;
        max-width: 330px;
        margin: 0 auto;
        position: relative;
        top: 30px;
      }

      .gap-1 {
        gap: 4px;
      }

      .line-item-desc-container {
        margin-bottom: 5px;
      }

      .title {
        color: #0a0a0a;
        font-size: 14px;
        font-weight: 400;
        line-height: 132%;
      }
      .type {
        color: #231f20;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 130%;
      }

      .price-container {
        display: flex;
        flex-direction: column;
        column-gap: 4px;
        text-align: right;
      }

      .gwp-price-container {
        display: flex;
        flex-direction: column;
        column-gap: 4px;
        text-align: right;
        min-width: 50px;
      }

      .compare-price {
        color: #626261;
        font-size: 12px;
      }

      .frequency-text {
        font-family: ABC Oracle;
        font-size: 10px;
        font-weight: 400;
        line-height: 10px;
        text-align: left;
        color: #0a0a0a;
      }

      .variant-option {
        color: #626261;
        font-size: 10px;
        display: flex;
        line-height: 148%;
      }
      /* Main Cart/Cart Page Styles */
      .cart-drawer[main='true'] .loading-container {
        height: auto;
      }

      .cart-drawer[main='true'] .continue-shopping {
        margin-top: 15px;
        text-decoration: underline;
        text-align: center;
      }
      .cart-drawer[main='true'] .continue-shopping a {
        color: #000;
      }

      .cart-drawer[main='true'] .cart-drawer_body.is-empty .cart-drawer_products {
        width: 100%;
        overflow-y: hidden;
      }

      .cart-drawer[main='true'] .cart-drawer_body.is-empty .cart-drawer_details {
        display: none;
      }

      .cart-drawer[main='true'] .cart-drawer_body.is-empty {
        margin-bottom: -64px;
      }

      .cart-drawer[main='true'] {
        border: none;
      }

      @media (min-width: 800px) {
        .cart-drawer[main='true'] .cart-drawer_body.is-empty {
          margin-bottom: -80px;
        }

        .cart-drawer[main='true'] {
          max-width: 1080px;
          margin: 0 auto;
          border: none;
        }

        .cart-drawer[main='true'] .loading-container {
          margin-right: 45px;
        }

        .cart-drawer[main='true'] .loading-container {
          width: 70%;
          height: auto;
        }

        .cart-drawer[main='true'] header {
          padding: 0;
          margin: 0 0 15px 0;
        }

        .cart-drawer[main='true'] .cart-drawer_body:not(.is-empty) .cart-scroll-blur {
          width: calc(100% - 35px);
          height: 60px;
          background-image: linear-gradient(180deg, transparent 18%, #fff 75%);
          position: absolute;
          bottom: 0px;
        }

        .cart-drawer[main='true'] .empty-cart {
          flex-direction: row;
          align-items: center;
          max-width: 950px;
          margin: 0 auto;
        }

        .cart-drawer[main='true'] .cart-drawer_body {
          display: flex;
        }

        .cart-drawer[main='true'] .cart-drawer_body .cart-drawer_products {
          width: 100%;
          height: auto;
          max-height: 306px;
          padding: 0 35px 0 0;
          overflow: auto;
        }

        .cart-drawer[main='true'] .cart-drawer_body.is-empty .cart-drawer_products {
          max-height: 100%;
        }

        .cart-drawer[main='true'] .cart-drawer_products .cart-item:last-child {
          margin-bottom: 25px;
        }

        .cart-drawer[main='true'] .cart-drawer_products-wrap {
          margin: 0 10px 0 0;
          width: 65%;
        }

        .cart-drawer[main='true'] .cart-drawer_body.is-empty .cart-drawer_products-wrap {
          margin: 0;
          width: 100%;
        }

        .cart-drawer[main='true'] .cart-drawer_body .cart-drawer_details {
          width: 35%;
        }

        .cart-drawer[main='true'] .cart-drawer_body .cart-drawer_bottom {
          width: 100%;
          border-radius: 10px;
          padding: 20px 20px 30px 20px;
        }
      }

      .cart-drawer[main='true'] header {
        padding: 0;
      }

      .discount-code-form {
        border-bottom: 1px solid #e5e5e5;
        padding-bottom: 20px;
        margin-bottom: 16px;
      }

      .discount-code-form > input {
        padding: 10px 15px;
        border: 1px solid #bfbbbb;
        width: 60%;
        border-radius: 0;
        font-size: 16px;
      }

      .discount-code-form > button {
        background: #000;
        color: #fff;
        font-size: 16px;
        width: 40%;
        border: none;
        align-items: center;
        font-weight: 500;
        justify-content: center;
        display: flex;
      }

      .discount-code-form > button > .apply-text {
        display: block;
      }

      .discount-code-form > button > .applied-text {
        display: none;
      }

      .discount-code-form.discount-applied > button > .apply-text {
        display: none;
      }

      .discount-code-form.discount-applied > button > .applied-text {
        display: block;
      }

      .discount-code-form > button svg {
        display: none;
      }

      .discount-code-form > button[data-loading='true'] .applied-text,
      .discount-code-form > button[data-loading='true'] .apply-text {
        display: none;
      }

      .discount-code-form > button[data-loading='true'] svg {
        display: block;
        width: 20px;
        height: 20px;
      }

      .discount-code-form.discount-applied > input {
        color: #888;
        opacity: 1;
      }

      .discount-code-form > input.input-active {
        text-transform: uppercase;
      }

      /* Upsells */
      .cart-drawer_upsells {
        display: grid;
        gap: 12px;
        padding: 20px 0px 20px 0px;
        background-color: #fff;
      }

      .side-cart-upsell-card-header {
        font-size: 16px;
        font-weight: 400;
        margin: 0;
        padding: 0px 20px 0px 20px;
      }

      .cart-drawer_upsells-container {
        display: flex;
        flex-direction: column;
        place-content: flex-end;
        height: 100%;
      }

      .side-cart-upsell-card-image-container {
        position: relative;
        display: flex;
      }

      .side-cart-upsell-card-image-container img {
        aspect-ratio: 41/25;
        width: 100%;
        object-fit: cover;
        border-radius: 2px 2px 0 0;
      }

      .side-cart-upsell-card-add-button-container {
        position: absolute;
        top: 8px;
        right: 8px;
      }

      .side-cart-upsell-card-add-button {
        padding: 6px 12px;
        font-size: 12px;
        border-radius: 100px;
        border: none;
        color: #fff;
        background-color: #0a0a0a;
      }

      .cart-drawer_upsells-container.is-empty {
        display: hidden;
      }

      .side-cart-upsell-products-container {
        overflow-x: scroll;
        scroll-snap-type: x mandatory;
        scroll-padding-left: 20px;
        scroll-padding-right: 20px;
      }

      .side-cart-upsell-products {
        display: flex;
        list-style-type: none;
        flex-wrap: nowrap;
        gap: 8px;
        width: fit-content;
        margin: 0px;
        padding: 0px 20px 0px 20px;
        scroll-snap-type: x mandatory;
      }

      .side-cart-upsell-card {
        width: 172px;
        display: flex;
        flex-direction: column;
        scroll-snap-align: start;
        border: 1px solid #dcdcda;
        border-radius: 2px;
      }

      @media (max-width: 800px) {
        .side-cart-upsell-card {
          width: 164px;
        }
      }

      .side-cart-upsell-card-details {
        display: flex;
        flex-grow: 1;
      }

      .side-cart-upsell-card-desc-container {
        border-radius: 0px 0px 2px 2px;
        background: #f4f4f2;
        padding: 8px;
        gap: 8px;
        display: flex;
        flex-direction: column;
        width: 100%;
      }

      .side-cart-upsell-card-product-info-container {
        display: grid;
        gap: 4px;
      }

      .side-cart-upsell-card-title {
        color: #0a0a0a;
        font-size: 12px;
        font-weight: 400;
      }

      .side-cart-upsell-card-category {
        color: #626261;
        font-size: 10px;
        font-weight: 300;
        line-height: 140%;
      }

      .side-cart-upsell-card-price-container {
        display: flex;
        gap: 4px;
      }

      .side-cart-upsell-card-price {
        font-size: 12px;
        font-weight: 400;
      }

      .side-cart-upsell-card-compare-price {
        color: #626261;
        font-size: 12px;
        text-decoration: line-through;
      }

      /* Buckets */
      .cart-bucket {
        background-color: #fff;
        box-shadow: 0px 0px 5px 0px #0000000d;
        border-radius: 2px;
        margin: 16px;
      }

      .cart-bucket_header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #dcdcda;
        padding: 6px 12px;
      }

      .cart-bucket_title {
        font-size: 12px;
        font-weight: 400;
        line-height: 12px;
        letter-spacing: 0em;
        margin: 0px;
        column-gap: 4px;
        display: flex;
        align-items: baseline;
      }

      .cart-bucket_title svg {
        position: relative;
        top: 1px;
      }

      .cart-bucket_desc {
        font-size: 12px;
        font-weight: 400;
        line-height: 12px;
        letter-spacing: 0em;
        letter-spacing: 0em;
        text-align: left;
      }

      .cart-bucket_products {
        padding: 0px;
        list-style-type: none;
        margin: 0;
      }

      .cart-bucket.m-0 {
        margin: 0px;
      }

      /* Empty Cart Tiles */
      .empty-cart_tiles-container {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 24px;
        padding: 24px 38px;
      }

      .empty-cart_tiles-container img:hover {
        transform: scale(1.05);
        transition: transform 0.2s ease-in-out;
      }

      .empty-cart_tile-card {
        border-radius: 2px;
        box-shadow: 0px 0px 5px 0px #0000000d;
        display: flex;
        flex-direction: column;
        overflow: hidden;
      }

      .empty-cart_tile-card .image-container {
        overflow: hidden;
      }

      .empty-cart_tile-label {
        color: #0a0a0a;
        text-align: center;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 130%;
        margin: 0;
        padding: 8px;
        background-color: #fff;
        flex-grow: 1;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      /* Help Card */
      .empty-cart_help-card {
        border-radius: 2px;
        overflow: hidden;
        box-shadow: 0px 0px 5px 0px #0000000d;
        background-color: #fff;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 32px;
        margin: 0 38px;
        gap: 4px;
        font-weight: 400;
        font-size: 16px;
        color: #0a0a0a;
      }

      /* Empty Cart Tiles */
      .empty-cart_tiles-container {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 24px;
        padding: 24px 38px;
      }

      .empty-cart_tile-card {
        border-radius: 2px;
        box-shadow: 0px 0px 5px 0px #0000000d;
        display: flex;
        flex-direction: column;
        overflow: hidden;
      }

      .empty-cart_tile-image {
        aspect-ratio: 1;
        width: 100%;
        display: block;
      }

      /* Help Card */
      .empty-cart_help-card {
        border-radius: 2px;
        overflow: hidden;
        box-shadow: 0px 0px 5px 0px #0000000d;
        background-color: #fff;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 32px;
        margin: 0 38px;
        gap: 4px;
        font-weight: 400;
        font-size: 16px;
        color: #0a0a0a;
      }

      .empty-cart_shop-all {
        color: #626261;
        text-align: center;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 150%; /* 18px */
        letter-spacing: 1px;
      }

      /* Primary Button */
      .btn-primary {
        background-color: #0a0a0a;
        width: 100%;
        color: #fff;
        font-size: 14px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        border: none;

        padding: 17px 48px;
        border-radius: 100px;
        text-transform: uppercase;
        transition-duration: 0.2s;
        transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
        transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
      }

      .btn-primary:hover {
        background: #08906e;
        color: #0a0a0a;
      }

      .btn-primary:focus {
        outline: 2px solid #458fff;
        outline-offset: 2px;
      }

      .btn-primary:active {
        background: #08906e;
        color: #0a0a0a;
      }

      .btn-tertiary {
        padding: 6px 12px;
        border-radius: 2px;
        border: 1px solid #0a0a0a;
        color: #0a0a0a;
        background-color: #fff;
        transition-duration: 0.2s;
        transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
        transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
        font-size: 12px;
        line-height: 12px;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        text-decoration-line: none;
        font-weight: 400;
      }

      .btn-tertiary:hover {
        background: #f4f4f2;
        color: #0a0a0a;
      }

      .btn-tertiary:focus {
        outline: 2px solid #458fff;
        outline-offset: 2px;
      }

      .btn-tertiary:active {
        background: #dddddb;
        color: #0a0a0a;
      }

      /* line item message */
      .cart-item.cart-item-with-message {
        padding-bottom: 16px;
      }

      .cart-item:not(:last-child).cart-item-with-message {
        border-bottom: 0.5px solid #dcdcda;
      }

      .cart-drawer .cart-item:not(:last-child).cart-item-with-message .cart-item_border {
        border: 0px;
      }

      .line-item-message-container {
        padding: 8px;
        border-radius: 2px;
        gap: 4px;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }

      .line-item-message-header {
        font-size: 12px;
        font-weight: 400;
        line-height: 12px;
      }

      .line-item-message-description {
        font-size: 12px;
        font-weight: 300;
        line-height: 16px;
      }

      .line-item-message-description p {
        margin: 0;
      }

      .line-item-message-description a {
        text-decoration: underline;
        color: inherit;
      }

      .line-item-sub-upsell {
        background-color: #97cff6;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 6px 8px 6px 8px;
        gap: 4px;
        border-radius: 2px;
        font-size: 12px;
        line-height: 12px;
        font-weight: 400;
        font-family: ABC Oracle;
      }

      .line-item-sub-upsell add-button {
        height: 18px;
        width: 18px;
        border-radius: 100%;
        background-color: white;
        color: #0a0a0a;
        border: 1px solid #0a0a0a;
        box-shadow: 0px 0px 7.5px 0px #0000001a;
        justify-content: center;
        display: flex;
        align-items: center;
        cursor: pointer;
      }

      //Cart Bottom Lines Styles
      .cart-drawer_bottom-line {
        font-family: ABC Oracle;
        font-size: 14px;
        font-weight: 400;
        line-height: 16.13px;
        text-align: left;
      }

      .cart-drawer_bottom-line h5 {
        font-family: ABC Oracle;
        font-size: 14px;
        font-weight: 400;
        line-height: 16.13px;
        text-align: left;
      }

      .cart-drawer_bottom-line-container {
        row-gap: 8px;
      }

      .cart-drawer.loop-active {
        height: calc(100% - 75px);
      }

      .text-pine {
        color: #077f61;
      }

      .cart-message {
        background-color: #dcdcda;
        box-shadow: 0px 0px 10px 0px #0000001a;
        margin: 0;
        padding: 4px;
        display: none;
        align-items: center;
        gap: 8px;
        min-height: 36px;
      }

      .cart-message p {
        color: #0a0a0a;
        font-family: 'ABC Oracle', 'Arial', 'Helvetica', 'sans-serif';
        font-weight: 400;
        font-size: 12px;
        margin: 0;
      }

      .cart-message svg {
        color: #626261;
      }

      .cart-message svg path {
        color: #dcdcda;
      }
    `,
  ]

  static properties = {
    count: { type: Number },
    cartItems: { type: Array },
    upsells: { type: Array },
    hide: { type: Boolean },
    main: { type: Boolean },
    subtotal: { type: Number },
    discount: { type: String },
    discountLoading: { type: Boolean },
    lowestFrequency: { type: Number },
    cartBottomStyle: { type: String },
    testIsControl: { type: Boolean },
    testVariant: { type: String, reflect: true },
    oneMonthLineItemUpsellEnabled: { type: String, reflect: true },
    threeMonthLineItemUpsellEnabled: { type: String, reflect: true },
    testOffer: { type: String, reflect: true },
  }

  constructor() {
    super()
    this.url = new URL(window.location)
    this.assets = this.url.host === '127.0.0.1:9292' ? `${this.url.origin}/assets/` : window.Needed_Store.asset_url
    this.store = window.Needed_Store
    this.evergreenPromo = this.store.settings.evergreen_promo_sale
    this.evergreenSavings = 0
    this.subtotal = 0
    this.oneTimeItems = []
    this.subscriptionItems = []
    this.testIsControl = true
    this.params = this.url.searchParams
    this.cartBuckets = false
    this.testOffer = false
    if (this.params.get('discount_code')) {
      sessionStorage.setItem('_discount_code', this.params.get('discount_code').toUpperCase())
    }
    this.discountCode = sessionStorage.getItem('_discount_code') ?? '' // need to check for session storage
  }

  _setCart() {
    return new Promise(async (resolve) => {
      shopifyCart.fetchNewCart().then(async (res) => {
        this.ogSubtotal = res.total_price
        this.ogTotalSavings = 0
        for (let item of res.items) {
          if (item.compare_at_price && item.compare_at_price != item.line_price) {
            this.ogTotalSavings += (item.compare_at_price - item.original_price) * item.quantity
          } else if (item.price > item.line_price) {
            this.ogTotalSavings += (item.price - item.line_price) * item.quantity
          }
        }
        this.hasSubscription =
          res.items.filter((item) => item?.hasOwnProperty('selling_plan_allocation') == true)?.length > 0 ? true : false
        this.hasOnetime =
          res.items.filter((item) => !item?.hasOwnProperty('selling_plan_allocation'))?.length > 0 ? true : false
        this.oneTimeItems = res.items.filter((item) => !item?.hasOwnProperty('selling_plan_allocation'))
        this.subscriptionItems = res.items.filter((item) => item?.hasOwnProperty('selling_plan_allocation'))

        this.subscriptionItemsTotalQuantity = this.subscriptionItems.reduce((acc, item) => (acc += item.quantity), 0)
        this.subscriptionItemsSubtotal = this.subscriptionItems.reduce(
          (acc, item) => (acc += item.discounted_price * item.quantity),
          0
        )

        this.planItems = res.items.filter((item) => item?.handle.includes('-plan'))
        this.cartToken = res.token
        this.count = res.item_count
        window.MicroBus.emit('count-change', { count: this.count })
        this.gwpActive =
          (this.gift_with_purchase.enabled && this.gwpVariantId && this.gift_with_purchase.subscription_required == false) ||
          (this.gift_with_purchase.enabled &&
            this.gwpVariantId &&
            this.gift_with_purchase.subscription_required &&
            this.hasSubscription)
            ? true
            : false
        this.gwpThresold = this.gift_with_purchase.threshold * 100
        this.gwpThresholdMet = false
        if (
          (this.gift_with_purchase.enabled &&
            this.gwpVariantId &&
            this.gift_with_purchase.subscription_required == false &&
            this.ogSubtotal > this.gwpThresold) ||
          (this.gift_with_purchase.enabled &&
            this.gwpVariantId &&
            this.gift_with_purchase.subscription_required == true &&
            this.hasSubscription &&
            this.ogSubtotal > this.gwpThresold)
        ) {
          this.gwpThresholdMet = true
          $('[data-gwp-threshold-met]').attr('data-gwp-threshold-met', 'true')
        } else {
          $('[data-gwp-threshold-met]').attr('data-gwp-threshold-met', 'false')
        }
        this.ogTotalSavings = centsToDollars(this.ogTotalSavings)
        if (this.discountCode && this.count > 0 && this.discountCodeEnabled) {
          let info = await this._getDiscount(this.discountCode)
          this._setDiscountCodeInfo(info)
        } else {
          this.subtotal = centsToDollars(res.total_price)
          this.totalSavings = centsToDollars(res.total_savings)
          if (
            this.hasSubscription &&
            res?.cart_level_discount_applications.length == 0 &&
            this.planItems.length != res.items.length &&
            res?.total_discount == 0 &&
            !this.testIsControl
          ) {
            this.subscriptionTotal = this.subscriptionItems.reduce((acc, item) => (acc += item.line_price), 0)
            this.evergreenSavings =
              this.evergreenPromo.enabled && this.evergreenPromo.discount_percent
                ? this.subscriptionTotal * (this.evergreenPromo.discount_percent / 100)
                : 0
          } else {
            this.evergreenSavings = 0
          }
        }

        const cartContainer = document.querySelector('cart-drawer')
        this.testOffer = cartContainer.getAttribute('testOffer')
        this.cart = res
        this.cartItems = res.items
        this.totalCompare = centsToDollars(res.total_price + res.total_savings)
        this.itemsText = this.count === 1 ? 'item' : 'items'

        if (this.main) {
          const el = $(this)
          const initialLoader = $('.js-initial-loading')
          initialLoader.hide()
          initialLoader.attr('aria-hidden', 'true')
          el.removeClass('hidden')
        }

        this.upsells = await this.getProductUpsells()
        this.upsells = this.upsells.filter(
          (product) =>
            product.handle.includes('prenatal-multi-essentials') == false &&
            product.handle.includes('the-starter-plan') == false
        )

        this.upsells = await this.getUpsellMeta(this.upsells)
        this.upsells = await this.getThreeMonthProducts(this.upsells)

        await this.updateLegalText()

        this.requestUpdate()
        resolve(res)
      })
    })
  }

  async updateLegalText() {
    let legalCheckoutExplainerText = ''
    let oneMonthItems = []
    let oneMonthFrequency = 28
    let threeMonthItems = []
    let threeMonthFrequency = 84
    let sixMonthItems = []
    let sixMonthFrequency = 168

    this.cartItems.forEach((item) => {
      if (item.selling_plan_allocation) {
        const plan = item.selling_plan_allocation.selling_plan
        const price = centsToDollars(item.price)
        const frequency = plan.options.filter((option) => option.name == 'Order Frequency and Unit')[0].value
        const days = parseInt(frequency.split('-')[0])

        if (days <= 30) {
          oneMonthItems.push({ title: item.product_title, price: price, quantity: item.quantity })
          oneMonthFrequency = days
        } else if (days <= 90) {
          threeMonthItems.push({ title: item.product_title, price: price, quantity: item.quantity })
          threeMonthFrequency = days
        } else {
          sixMonthItems.push({ title: item.product_title, price: price, quantity: item.quantity })
          sixMonthFrequency = days
        }
      }
    })

    const generateLegalText = (items, frequency) => {
      if (items.length === 0) return ''

      return (
        items
          .map((item) => {
            const itemPrice = parseFloat(parseFloat(item.price) * (item.quantity || 1)).toFixed(2)
            return `${item.title} will renew at $${itemPrice} every ${frequency} days`
          })
          .join('; ') + ';'
      )
    }

    const legalTexts = [
      generateLegalText(oneMonthItems, oneMonthFrequency),
      generateLegalText(threeMonthItems, threeMonthFrequency),
      generateLegalText(sixMonthItems, sixMonthFrequency),
    ]

    legalCheckoutExplainerText = legalTexts.join(' ').trim()
    legalCheckoutExplainerText = legalCheckoutExplainerText.replace(/;$/, '')

    if (this.cart.attributes.legal_text != legalCheckoutExplainerText) {
      await shopifyCart.addAttribute({ legal_text: legalCheckoutExplainerText })
    }
  }

  async getThreeMonthProducts(upsells) {
    if (!upsells.length) return []
    if (this.lowestFrequency > 1) return upsells

    const promises = []
    upsells.forEach((upsell) => {
      promises.push(getProduct(upsell.handle + '-trimester-bundle-3-month-supply'))
    })

    const threeMonthUpsellsData = await Promise.all(
      promises.map(async (res) => {
        return await res
      })
    )
    upsells.forEach((upsell, idx) => {
      const currentVariant = threeMonthUpsellsData[idx].variants.find(
        (variant) => variant?.title === upsell.variants[0]?.title
      )
      upsell.threeMonthVariantId = currentVariant?.id
      upsell.threeMonthSellingPlanId = currentVariant?.selling_plan_allocations[0].selling_plan_id
    })
    return upsells
  }

  async getProductUpsells() {
    let promises = []
    const cartIds = this.cartItems.map((item) => item.product_id)
    let lowestFrequencyItems = []

    // Determine lowest delivery frequency
    if (
      this.cartItems.filter(
        (item) => item.hasOwnProperty('selling_plan_allocation') == false && item?.properties?._is_gift != true
      ).length > 0
    ) {
      this.lowestFrequency = 0
      lowestFrequencyItems = this.cartItems.filter((item) => item.hasOwnProperty('selling_plan_allocation') == false)
    } else if (
      this.cartItems.filter(
        (item) =>
          item.selling_plan_allocation?.selling_plan?.options[0]?.value == '30 Day(s)' ||
          item.selling_plan_allocation?.selling_plan?.options[0]?.value == '28 Day(s)' ||
          item?.selling_plan_allocation?.selling_plan?.name.includes('28 days') ||
          item?.selling_plan_allocation?.selling_plan?.name.includes('30 days')
      ).length > 0
    ) {
      this.lowestFrequency = 1
      lowestFrequencyItems = this.cartItems.filter(
        (item) =>
          item.selling_plan_allocation?.selling_plan?.options[0]?.value == '30 Day(s)' ||
          item.selling_plan_allocation?.selling_plan?.options[0]?.value == '28 Day(s)' ||
          item?.selling_plan_allocation?.selling_plan?.name.includes('28 days') ||
          item?.selling_plan_allocation?.selling_plan?.name.includes('30 days')
      )
    } else if (
      this.cartItems.filter(
        (item) =>
          item.selling_plan_allocation?.selling_plan?.options[0]?.value == '90 Day(s)' ||
          item.selling_plan_allocation?.selling_plan?.options[0]?.value == '84 Day(s)' ||
          item.selling_plan_allocation?.selling_plan?.options[0]?.value == '3 Month(s)' ||
          item?.selling_plan_allocation?.selling_plan?.name.includes('84 days') ||
          item?.selling_plan_allocation?.selling_plan?.name.includes('90 days') ||
          item?.selling_plan_allocation?.selling_plan?.name.includes('3 months')
      ).length > 0
    ) {
      this.lowestFrequency = 3
      lowestFrequencyItems = this.cartItems.filter(
        (item) =>
          item.selling_plan_allocation?.selling_plan?.options[0]?.value == '90 Day(s)' ||
          item.selling_plan_allocation?.selling_plan?.options[0]?.value == '84 Day(s)' ||
          item.selling_plan_allocation?.selling_plan?.options[0]?.value == '3 Month(s)' ||
          item?.selling_plan_allocation?.selling_plan?.name.includes('84 days') ||
          item?.selling_plan_allocation?.selling_plan?.name.includes('90 days') ||
          item?.selling_plan_allocation?.selling_plan?.name.includes('3 months')
      )
    } else if (
      this.cartItems.filter(
        (item) =>
          item.selling_plan_allocation?.selling_plan?.options[0]?.value == '6 Month(s)' ||
          item.selling_plan_allocation?.selling_plan?.options[0]?.value == '180 Day(s)' ||
          item.selling_plan_allocation?.selling_plan?.options[0]?.value == '168 Day(s)' ||
          item?.selling_plan_allocation?.selling_plan?.name.includes('6 months') ||
          item?.selling_plan_allocation?.selling_plan?.name.includes('180 days') ||
          item?.selling_plan_allocation?.selling_plan?.name.includes('168 days')
      ).length > 0
    ) {
      this.lowestFrequency = 6
      lowestFrequencyItems = this.cartItems.filter(
        (item) =>
          item.selling_plan_allocation?.selling_plan?.options[0]?.value == '6 Month(s)' ||
          item.selling_plan_allocation?.selling_plan?.options[0]?.value == '180 Day(s)' ||
          item.selling_plan_allocation?.selling_plan?.options[0]?.value == '168 Day(s)' ||
          item?.selling_plan_allocation?.selling_plan?.name.includes('6 months') ||
          item?.selling_plan_allocation?.selling_plan?.name.includes('180 days') ||
          item?.selling_plan_allocation?.selling_plan?.name.includes('168 days')
      )
    }

    lowestFrequencyItems.forEach(({ product_id }) => {
      promises.push(
        fetch(`/recommendations/products.json?product_id=${product_id}&limit=4&intent=complementary`).then((res) =>
          res.json()
        )
      )
    })
    const recs = await Promise.all(
      promises.map(async (res) => {
        const { products } = await res
        return products
      })
    )
    const temp = recs.reduce((prev, curr) => [...prev, ...curr], [])

    const tempUnique = new Set()
    const unique = temp.filter((el) => {
      const duplicate = tempUnique.has(el.id)
      tempUnique.add(el.id)
      return !duplicate && el.available == true && cartIds.indexOf(el.id) == -1
    })
    return unique
  }

  async getUpsellMeta(upsells) {
    if (upsells.length > 0) {
      let promises = []
      upsells.forEach((product) => {
        promises.push(
          fetch(`/products/${product.handle}?view=upsell-meta`).then((res) => {
            return res.json()
          })
        )
      })

      let newUpsells = []
      const meta = await Promise.all(
        promises.map(async (res) => {
          return await res
        })
      )
      for (let i = 0; i < meta.length; i++) {
        const tempUpsell = this.upsells.filter((el) => el.id == meta[i].product_id)[0]
        tempUpsell.upsell_title = meta[i].display_title ?? ''
        tempUpsell.upsell_description = meta[i].short_description ?? ''
        newUpsells.push(tempUpsell)
      }
      return newUpsells
    } else {
      return []
    }
  }

  connectedCallback() {
    super.connectedCallback()

    this.count = 0
    this.cartItems = []
    this.upsells = []
    this.hide = true
    this.main = this.main ?? false
    this.totalSavings = 0
    this.hasSubscription = false
    this.subscriptionItemsTotalQuantity = 0
    this.itemsText = this.count === 1 ? 'item' : 'items'
    this.store = window.Needed_Store
    this.settings = this.store.settings
    this.empty_cart = this.settings.empty_cart
    this.shop_all_url = this.settings.shop_all_url
    this.discountCodeEnabled = this.settings.cart_discount_enabled
    this.gift_with_purchase = this.settings.gift_with_purchase
    this.gwpVariantId = this.gift_with_purchase.product?.variants?.at(0)?.id
    this.discountLoading = false
    this.bundleMinimum = 3
    this.lowestFrequency
    this.getInitialCart() //fetch cart data and build cart html
    this.testIsControl = true

    window.addEventListener('ig:ready', () => {
      const experiment = window?.igData?.user.getTestGroup('abb54ad9-513d-4f25-8fb5-d93a68d1ba4f')
      this.testIsControl = experiment?.isControl == false ? false : true
    })

    window.MicroBus.on('cart:add', async (e) => {
      this._setLoadingState(true)
      if (e.detail.variant_id) {
        this._setLoadingState(true)
        let quantity = e.detail?.quantity ?? 1
        let selling_plan = e.detail?.selling_plan ?? null
        await shopifyCart.add(quantity, e.detail?.variant_id, e.detail?.properties, selling_plan)
        if (e.detail?.disableCartToggle === false) {
          window.MicroBus.emit(`side-cart:toggle`)
        }

        await this._setCart()
        await this._updateGWP()

        //Cart Interstitial Logic
        const addedItem = this.cartItems.find((item) => item.id == e.detail?.variant_id) //get newly added item from cart items
        const interstitialNeverSeen = sessionStorage.getItem('_interstitial_pop') ? false : true
        const onlyShowIfSubscription = addedItem?.cart_interstitial?.only_upsell_to_subscriptions == true ?? false
        const addedItemIsSubscription = addedItem?.selling_plan_allocation ? true : false
        if (
          addedItem?.cart_interstitial &&
          ((interstitialNeverSeen && addedItem?.cart_interstitial?.always_show !== true) ||
            addedItem?.cart_interstitial?.always_show == true)
        ) {
          if ((onlyShowIfSubscription && addedItemIsSubscription) || !onlyShowIfSubscription) {
            const detail = {
              ...addedItem.cart_interstitial,
              parent_variant_id: addedItem.variant_id,
              parent_key: addedItem.key,
              parent_title: addedItem.product_title,
              parent_price: addedItem.price,
            }

            const testVariant = $('#side-cart-interstitial').attr('data-ig-test-variant') || 'control'
            const hideByDefault = addedItem?.cart_interstitial?.is_testing
            //show interstitial if item is not in control or not hidden by default
            if (testVariant != 'control' || (!hideByDefault && testVariant == 'control')) {
              this._openCartInterstitial(detail)
              sessionStorage.setItem('_interstitial_pop', 'true')
            }
          }
        }

        this._setLoadingState(false)
      }
    })

    window.MicroBus.on('cart:swap', async ({ detail }) => {
      const { parent_key, selling_plan, variant_id, properties, quantity } = detail

      if (parent_key && variant_id && quantity != undefined) {
        this._setLoadingState(true)
        try {
          await shopifyCart.change(0, parent_key)
          await shopifyCart.add(quantity, variant_id, properties, selling_plan)
          await this._setCart()
          await this._updateGWP()
        } catch (e) {
          console.log(e)
        }
        this._setLoadingState(false)
      }
    })

    window.MicroBus.on('cart:change-quantity', async (e) => {
      const { key, quantity } = e.detail
      if (key && quantity != undefined) {
        this._setLoadingState(true)
        try {
          await shopifyCart.change(quantity, key)
          await this._setCart()
          await this._updateGWP()
        } catch (e) {
          console.log(e)
        }
        this._setLoadingState(false)
      }
    })

    window.MicroBus.on('cart:refresh', async () => {
      this.getInitialCart()
    })
  }

  firstUpdated() {
    const cartDrawer = this.shadowRoot.querySelector('.cart-drawer')
    const sideCart = document.getElementById('side-cart')
    const announcementHeader = this.shadowRoot.querySelector('.gift-with-purchase_one-time-header')

    const observer = new MutationObserver(() => {
      if (announcementHeader && announcementHeader.offsetHeight > 0) {
        sideCart.firstElementChild.style.top = `${announcementHeader.offsetHeight - 1}px`
      }
    })

    observer.observe(cartDrawer, {
      attributes: true,
      subtree: true,
      childList: true,
    })
  }

  async getInitialCart() {
    await this._setCart()
    await this._updateGWP()
  }

  async _updateGWP() {
    const gwpItem = this.cartItems.find((item) => item?.properties?._is_gift == true)
    const isGWPinCart = !gwpItem ? false : true
    const gwpOnlyItemInCart = this.gwpActive && this.cartItems.length == 1 && isGWPinCart

    if (this.gwpActive && this.gwpThresholdMet && this.cartItems.length > 0 && !isGWPinCart && this.gwpVariantId) {
      await shopifyCart.add(1, this.gwpVariantId, { _is_gift: true }, null)
      this._setCart()
    } else if (!this.gwpActive || !this.gwpThresholdMet || gwpOnlyItemInCart) {
      await this._removeGWP()
    }
  }

  async _removeGWP() {
    const gwpItem = this.cartItems.find((item) => item?.properties?._is_gift == true)
    if (gwpItem) {
      await shopifyCart.change(0, gwpItem.key)
      this._setCart()
    }
  }

  _openCartInterstitial(detail) {
    window.MicroBus.emit('cart:open-interstitial', detail)
  }

  _setLoadingState(state) {
    const el = this.shadowRoot.querySelector('.cart-drawer')
    if (this.main) {
      const products = this.shadowRoot.querySelector('.cart-drawer_products')
      const loadingEl = this.shadowRoot.querySelector('.cart-drawer[main="true"] .loading-container')
      const height = products.offsetHeight
      loadingEl.style.height = height + 'px'
    }
    el.setAttribute('loading', state)
  }

  _renderComparePrice(comparePrice, quantity) {
    if (comparePrice) {
      return html` <s class="compare-price">$${centsToDollars(comparePrice * quantity)}</s> `
    }
  }

  _renderPrices(price, discountedPrice, comparePrice, quantity, oneTime) {
    if (discountedPrice < price) {
      return html`
        <div class="price-container">
          <div class="font-bold">$${centsToDollars(discountedPrice)}</div>
          ${oneTime != true ? html`<s class="compare-price">${this._renderComparePrice(comparePrice, quantity)}</s>` : ''}
        </div>
      `
    } else {
      return html`
        <div class="price-container">
          <div class="font-bold">$${centsToDollars(price)}</div>
          ${oneTime != true ? this._renderComparePrice(comparePrice, quantity) : ''}
        </div>
      `
    }
  }

  _variantTitle(variantTitle, productTitle) {
    variantTitle = productTitle ? variantTitle.replace(`${productTitle} /`, '') : variantTitle
    if (variantTitle) {
      return html`${variantTitle.replace(/ \//g, ',')}`
    }
  }

  _calcIndividualPrice(packSize, sizeUnit, price, discountedPrice, comparePrice, quantity) {
    let packNum = parseInt(packSize)
    let totalPacks = packNum * quantity
    if (packSize && packSize > 1 && sizeUnit) {
      if (discountedPrice < price) {
        return html`
          &nbsp;/&nbsp;
          <div class="flex">
            <s>$${centsToDollars(price / totalPacks)}</s>
            <span style="margin-left:5px;">$${centsToDollars(discountedPrice / totalPacks)} per ${sizeUnit}</span>
          </div>
        `
      } else if (comparePrice) {
        return html`
          &nbsp;/&nbsp;
          <div class="flex">
            <s>$${centsToDollars(comparePrice / totalPacks)}</s>
            <span style="margin-left:5px;">$${centsToDollars(price / totalPacks)} per ${sizeUnit}</span>
          </div>
        `
      } else {
        return html`&nbsp;/&nbsp; $${centsToDollars(price / totalPacks)} per ${sizeUnit}`
      }
    }
  }

  _renderSubscription(item) {
    if (item?.selling_plan_allocation?.selling_plan?.name) {
      const selling_plan_name = item?.selling_plan_allocation?.selling_plan?.name
      return html` <div class="cart-item-subscription">${selling_plan_name}</div> `
    }
  }

  _renderCartLineItems(freqArr) {
    if (freqArr) {
      return html` ${freqArr.map((freq) => {
        return html` ${this._renderCartBuckets(freq)} `
      })}`
    } else {
      return html` ${this.cartItems.map((item) => {
        let oneTime = item.hasOwnProperty('selling_plan_allocation') == false
        return html`${this._renderLineItem(item, oneTime)}`
      })}`
    }
  }

  _renderCartBuckets(freq = 0) {
    let bucketItems = []
    let bucketTitle = ''
    let bucketDesc = ''
    let bucketOneTime = false
    if (freq == 1) {
      bucketItems = this.cartItems
        .filter(
          (item) =>
            item.selling_plan_allocation?.selling_plan?.options[0]?.value == '28 Day(s)' ||
            item.selling_plan_allocation?.selling_plan?.options[0]?.value == '30 Day(s)'
        )
        .reverse()
      bucketTitle = 'Monthly Delivery'
      bucketDesc = '1-month supply, delivered every 28 days'
    } else if (freq == 3) {
      bucketItems = this.cartItems
        .filter(
          (item) =>
            item.selling_plan_allocation?.selling_plan?.options[0]?.value == '84 Day(s)' ||
            item.selling_plan_allocation?.selling_plan?.options[0]?.value == '90 Day(s)' ||
            item.selling_plan_allocation?.selling_plan?.options[0]?.value == '3 Month(s)'
        )
        .reverse()
      bucketTitle = '3 Month Delivery'
      bucketDesc = '3-month supply, delivered every 84 days'
    } else if (freq == 6) {
      bucketItems = this.cartItems
        .filter(
          (item) =>
            item.selling_plan_allocation?.selling_plan?.options[0]?.value == '6 Month(s)' ||
            item.selling_plan_allocation?.selling_plan?.options[0]?.value == '168 Day(s)' ||
            item.selling_plan_allocation?.selling_plan?.options[0]?.value == '180 Day(s)'
        )
        .reverse()
      bucketTitle = '6 Month Delivery'
      bucketDesc = '6-month supply, delivered every 168 days'
    } else if (freq == 'GWP') {
      bucketItems = this.cartItems.filter((item) => item.id == this.gwpVariantId)
      bucketTitle = `${this.gift_with_purchase.bucket_heading} `
      bucketDesc = this.gift_with_purchase.bucket_delivery_heading
    } else {
      bucketItems = this.cartItems.filter(
        (item) => item.hasOwnProperty('selling_plan_allocation') == false && item.id != this.gwpVariantId
      )
      bucketTitle = 'One-Time Purchase'
      bucketDesc = '1-month supply, delivered once'
      bucketOneTime = true
    }

    if (bucketItems.length > 0 || freq == 'GWP') {
      return html`
        <div class="cart-bucket">
          <div class="cart-bucket_header">
            <h3 class="cart-bucket_title">
              ${freq == 'GWP'
                ? html`<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M5.989 2.4216C5.676 1.59254 5.25847 0.913322 4.78053 0.487642C4.43221 0.177362 4.02689 -0.0188445 3.59327 0.00143554C3.15383 0.0219955 2.75255 0.261562 2.41219 0.681502C2.1006 1.06594 1.88288 1.45564 1.85413 1.84867C1.82285 2.27645 2.01849 2.62586 2.35194 2.89574C2.55581 3.06074 2.81933 3.20406 3.13555 3.33208H0.333333C0.244927 3.33208 0.16014 3.36861 0.0976334 3.43363C0.03512 3.49865 0 3.58685 0 3.6788L6.67572e-06 6.1058C6.67572e-06 6.29733 0.149247 6.45253 0.33334 6.45253H0.666667V11.3065C0.666667 11.6895 0.965147 12 1.33333 12H10.6667C11.0349 12 11.3333 11.6895 11.3333 11.3065V6.45253H11.6667C11.8507 6.45253 12 6.29733 12 6.1058V3.6788C12 3.48731 11.8507 3.33208 11.6667 3.33208H8.94227C9.18827 3.21605 9.39927 3.08592 9.57133 2.93981C9.9048 2.65663 10.1074 2.29718 10.1007 1.86994C10.0943 1.46138 9.8966 1.06182 9.58853 0.681669C9.25487 0.269989 8.84833 0.0449222 8.4062 0.0299022C7.97207 0.0151489 7.55653 0.204636 7.19693 111049C6.7044 0.930615 6.279 1.59852 5.989 2.4216ZM5.559 3.24877C4.90327 3.12958 4.35624 3.00511 3.91151 2.87113C3.35066 2.70216 2.98083 2.52611 2.76134 2.34847C2.55529 2.18171 2.50877 2.03945 2.51888 1.90127C2.53153 1.72834 2.63876 1.4778 2.92189 1.12846C3.17626 0.814629 3.41643 0.703842 3.62322 0.694169C3.83581 0.684229 4.08149 0.777915 4.34695 1.01436C4.8118 1.42839 5.25933 2.21511 5.559 3.24877ZM5.66667 4.02551H0.666667L0.666673 5.75907H5.66667V4.02551ZM5.66667 6.45253H1.33334L1.33333 11.3065H5.66667V6.45253ZM6.33333 11.3065V6.45253H10.6667V11.3065H6.33333ZM6.33333 5.75907V4.02551H11.3333V5.75907H6.33333ZM6.43493 3.27514C6.6794 2.24286 7.1356 1.45965 7.61933 1.0475C7.89367 0.813762 8.15647 0.715222 8.3844 0.722962C8.60433 0.730435 8.84353 0.838369 9.0788 1.12862C9.3396 1.45038 9.43133 1.69944 9.43413 1.88123C9.43673 2.04434 9.36833 2.21698 9.14967 2.40269C8.923 2.59519 8.5548 2.78166 8.01713 2.94439C7.5856 3.07502 7.059 3.18619 6.43493 3.27514Z"
                      fill="#0A0A0A"
                    />
                  </svg> `
                : ''}
              ${bucketTitle}
            </h3>
            <span class="cart-bucket_desc">${bucketDesc}</span>
          </div>
          <ul class="cart-bucket_products">
            ${freq != 'GWP'
              ? bucketItems.map((item) => {
                  return html`${this._renderLineItem(item, bucketOneTime)}`
                })
              : this._renderGWPLineItem(this.gift_with_purchase)}
          </ul>
        </div>
      `
    }
  }

  _renderLineItem(item, oneTime) {
    const omegaType = item?.options_with_values.filter((option) => option.name == 'Omega Type')[0]?.value
    const scentType = item?.options_with_values.filter((option) => option.name == 'Scent')[0]?.value
    const showScent = item?.show_scent_selector

    let upsellSellingPlanId
    if (oneTime) {
      upsellSellingPlanId = item.properties?._upsell_selling_plan_id
    }

    // check subscription length
    let subscriptionFrequencyText = '1-month supply, delivered once'
    if (
      item?.selling_plan_allocation?.selling_plan?.options[0]?.value == '28 Day(s)' ||
      item?.selling_plan_allocation?.selling_plan?.options[0]?.value == '30 Day(s)' ||
      item?.selling_plan_allocation?.selling_plan?.name.includes('28 days') ||
      item?.selling_plan_allocation?.selling_plan?.name.includes('30 days')
    ) {
      subscriptionFrequencyText = '1-month supply, delivered every 28 days'

      if (
        item.properties?._upsell_variant_id &&
        item.properties?._three_month_selling_plan_id &&
        !item?.plan_product_count
      ) {
        upsellSellingPlanId = item.properties?._three_month_selling_plan_id
      } else {
        if (item.properties?._upsell_selling_plan_id && !item?.plan_product_count) {
          upsellSellingPlanId = item.properties?._upsell_selling_plan_id
        }
      }
    } else if (
      item?.selling_plan_allocation?.selling_plan?.options[0]?.value == '84 Day(s)' ||
      item?.selling_plan_allocation?.selling_plan?.options[0]?.value == '90 Day(s)' ||
      item?.selling_plan_allocation?.selling_plan?.options[0]?.value == '3 Month(s)' ||
      item?.selling_plan_allocation?.selling_plan?.name.includes('84 days') ||
      item?.selling_plan_allocation?.selling_plan?.name.includes('90 days') ||
      item?.selling_plan_allocation?.selling_plan?.name.includes('3 months')
    ) {
      subscriptionFrequencyText = '3-month supply, delivered every 84 days'
    } else if (
      item?.selling_plan_allocation?.selling_plan?.options[0]?.value == '168 Day(s)' ||
      item?.selling_plan_allocation?.selling_plan?.options[0]?.value == '180 Day(s)' ||
      item?.selling_plan_allocation?.selling_plan?.options[0]?.value == '6 Month(s)' ||
      item?.selling_plan_allocation?.selling_plan?.name.includes('168 days') ||
      item?.selling_plan_allocation?.selling_plan?.name.includes('180 days') ||
      item?.selling_plan_allocation?.selling_plan?.name.includes('6 months')
    ) {
      subscriptionFrequencyText = '6-month supply, delivered every 168 days'
    }

    if (item?.properties?._is_gift) {
      const bucketTitle = `${this.gift_with_purchase.bucket_heading} `
      const bucketDesc = this.gift_with_purchase.bucket_delivery_heading
      return html`
        <div class="cart-bucket m-0">
          <div class="cart-bucket_header">
            <h3 class="cart-bucket_title">
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                <path
                  d="M4.10111 1.04288C5.18625 1.36903 6 3 6 3H3.28739C2.70866 2.337 3.01598 0.716728 4.10111 1.04288Z"
                  stroke="#0A0A0A"
                  stroke-width="0.5"
                />
                <path
                  d="M7.89889 1.04288C6.81375 1.36903 6 3 6 3H8.71261C9.29134 2.337 8.98402 0.716728 7.89889 1.04288Z"
                  stroke="#0A0A0A"
                  stroke-width="0.5"
                />
                <path
                  d="M1.5 5H10.5V10.5714C10.5 10.8081 10.3168 11 10.0909 11H1.90909C1.68316 11 1.5 10.8081 1.5 10.5714V5Z"
                  fill="white"
                  stroke="#0A0A0A"
                  stroke-width="0.5"
                />
                <path
                  d="M1 3.5C1 3.22386 1.18655 3 1.41667 3H10.5833C10.8135 3 11 3.22386 11 3.5V4.5C11 4.77614 10.8135 5 10.5833 5H1.41667C1.18655 5 1 4.77614 1 4.5V3.5Z"
                  fill="white"
                  stroke="#0A0A0A"
                  stroke-width="0.5"
                />
                <path d="M6 11L6 3" stroke="#0A0A0A" stroke-width="0.5" />
              </svg>
              ${bucketTitle}
            </h3>
            <span class="cart-bucket_desc">${bucketDesc}</span>
          </div>
          <ul class="cart-bucket_products">
            ${this._renderGWPLineItem(this.gift_with_purchase)}
          </ul>
        </div>
      `
    } else {
      return html` <li
        class="cart-item ${item.cart_variant_message.header || item.cart_variant_message.description
          ? 'cart-item-with-message'
          : ''}"
      >
        <div class="flex cart-item_border">
          <div class="left cart-item_image-container">
            <a href="${item.url}"
              ><img
                class="cart-item_image"
                src="${resizeImageSrc(item.featured_image.url, 300)}"
                srcset="
                  ${resizeImageSrc(item.featured_image.url, 180)} 180w,
                  ${resizeImageSrc(item.featured_image.url, 220)} 220w
                "
                sizes="110px"
                width="${item.featured_image.width}"
                height="${item.featured_image.height}"
                alt="${item.featured_image.alt}"
              />
            </a>
            ${item.plan_product_count
              ? html`<div class="cart-item_plan-count">${item.plan_product_count} Products</div>`
              : ''}
          </div>
          <div class="right flex flex-col justify-between test">
            <div class="flex justify-between gap-1">
              <div class="flex flex-col gap-1 line-item-desc-container">
                <a href="${item.url}" class="title">${unsafeHTML(item.display_title)}</a>
                <div class="frequency-text">${subscriptionFrequencyText}</div>
                ${item.prenatal_type ? html`<div class="variant-option">Prenatal Multi: ${item.prenatal_type}</div>` : ''}
                ${item.hydration_flavor
                  ? html`<div class="variant-option">Hydration Flavor: ${item.hydration_flavor}</div>`
                  : ''}
                ${omegaType ? html`<div class="variant-option">Omega Type: ${omegaType}</div>` : ''}
                ${scentType && showScent == true ? html`<div class="variant-option">Scent: ${scentType}</div>` : ''}
              </div>
              <div>
                ${this._renderPrices(
                  item.original_line_price,
                  item.line_price,
                  item.compare_at_price,
                  item.quantity,
                  oneTime
                )}
              </div>
            </div>
            <div class="flex">
              <div class="quantity-selector flex">
                <button
                  class="flex-1"
                  @click=${() => this._changeQuantity(item.key, item.quantity - 1, item.quantity, item)}
                  aria-label="Remove 1 ${item.display_title} from cart"
                  aria-disabled="${item?.properties?._is_gift ? 'true' : 'false'}"
                >
                  <img src="${this.assets}_icon-quantity-minus.svg" />
                </button>
                <input
                  type="number"
                  min="1"
                  max="99"
                  value=${item.quantity}
                  disabled
                  aria-label="total quantity of ${item.title} in cart"
                />
                <button
                  class="flex-1"
                  @click=${() => this._changeQuantity(item.key, item.quantity + 1, item.quantity, item)}
                  aria-label="Add 1 ${item.title} to cart"
                  aria-disabled="${item?.properties?._is_gift ? 'true' : 'false'}"
                >
                  <img src="${this.assets}_icon-quantity-plus.svg" />
                </button>
              </div>
              <button
                class="remove-btn"
                aria-label="Remove ${item.title} from cart"
                @click=${() => this._changeQuantity(item.key, 0, item.quantity, item)}
                aria-disabled="${item?.properties?._is_gift ? 'true' : 'false'}"
              >
                <img class="remove-btn_icon" src="${this.assets}_icon-cart-remove.svg" />
              </button>
            </div>
          </div>
        </div>
        ${item.cart_variant_message.header || item.cart_variant_message.description ? this._renderLineItemMessage(item) : ''}
        ${upsellSellingPlanId ? this._renderOTPSubUpsell(item, oneTime, upsellSellingPlanId) : ''}
      </li>`
    }
  }

  _renderLineItemMessage(item) {
    return html`<div
      class="line-item-message-container"
      style="background-color: ${item.cart_variant_message.background_color}; color: ${item.cart_variant_message.font_color}"
    >
      ${item.cart_variant_message.header
        ? html`<div class="line-item-message-header">${item.cart_variant_message.header}</div>`
        : ''}
      ${item.cart_variant_message.description
        ? html`<div class="line-item-message-description">
            ${unsafeHTML(unescapeStr(item.cart_variant_message.description))}
          </div>`
        : ''}
    </div>`
  }

  _renderOTPSubUpsell(item, oneTime, sellingPlanId) {
    const upsellText = oneTime ? 'Save 10% every month when you subscribe!' : 'Save an extra 5% with a 3 month supply!'
    const upsellVariantId = item.properties?._upsell_variant_id
    const upsellSellingPlanId = item.properties?._three_month_selling_plan_id

    let displayStr = 'none'
    if (oneTime && this.oneMonthLineItemUpsellEnabled == 'true') {
      displayStr = 'flex'
    } else if (!oneTime && this.threeMonthLineItemUpsellEnabled == 'true') {
      displayStr = 'flex'
    }

    return html`<div class="line-item-sub-upsell" style="display: ${displayStr};">
      ${upsellText}
      <add-button
        type="cart-subscription-upsell"
        data-three-month-upsell="${!oneTime}"
        data-variant-id="${!oneTime ? upsellVariantId : item.variant_id}"
        data-selling-plan-id="${sellingPlanId}"
        data-upsell-variant-id="${upsellVariantId}"
        data-upsell-selling-plan-id="${upsellSellingPlanId}"
        data-product-handle="${item.handle}"
        swap
        data-parent-key="${item.key}"
        disable-cart-toggle
        ><span style="display: flex; justify-content: center; align-items: center; margin-top: -2.5px; font-size: 18px;"
          >+</span
        ></add-button
      >
    </div>`
  }

  _renderGWPLineItem(item) {
    return html` <li class="cart-item">
      <div class="flex items-center cart-item_border">
        <div class="left cart-item_image-container">
            <img
              class="cart-item_image"
              src="${resizeImageSrc(item.product.featured_image, 194)}"
              width="194"
              height="191"
              alt=""
            />
          </a>
        </div>
        <div class="right flex flex-col justify-between">
          <div class="flex justify-between gap-1">
            <div class="flex flex-col gap-1 line-item-desc-container">
              <span class="title">${item.product_title}</span>
              <div class="variant-option">${item.product_short_description}</div>
            </div>
            <div class="gwp-price-container">
              <div class="font-bold">$${centsToDollars(item.product.price)}</div>
              ${
                item?.product?.compare_at_price
                  ? html`<s class="compare-price">$${centsToDollars(item.product.compare_at_price)}</s>`
                  : ''
              }
            </div>
          </div>
        </div>
      </div>
    </li>`
  }

  _renderCartTiles() {
    // We replace any explicit width on image sources (ie. 320x320 ), to use utils function resizeImageSrc.
    this.settings.empty_cart.tiles.forEach((tile) => (tile.image = tile.image.replace(/_([0-9]{1,}x[0-9]{1,})/, '')))
    return html`${this.settings.empty_cart.tiles.map(
      (tile) =>
        html`<a
          href="${tile.url}"
          class="empty-cart_tile-card"
          onclick="
        window.location.href = '${tile.url}';
        window.location.reload(true);"
        >
          <div class="image-container">
            <img
              class="empty-cart_tile-image"
              src="${resizeImageSrc(tile.image, 300)}"
              srcset="
                ${resizeImageSrc(tile.image, 185)} 185w,
                ${resizeImageSrc(tile.image, 250)} 250w,
                ${resizeImageSrc(tile.image, 300)} 300w,
                ${resizeImageSrc(tile.image, 350)} 350w,
                ${resizeImageSrc(tile.image, 420)} 420w
              "
              sizes="(min-width: 465px) 182px, 45vw"
              alt="${tile.label}"
            />
          </div>
          <h2 class="empty-cart_tile-label">${tile.label}</h2>
        </a>`
    )}`
  }

  updated() {
    window.MicroBus.emit('side-cart:updated', { id: 'side-cart' })
  }

  _discountInputHandler() {
    let input = this.shadowRoot.querySelector('.js-discount-code-form > input')
    let code = input.value
    if (this.discountCode && this.discountCode !== code) {
      this.shadowRoot.querySelector('.js-discount-code-form').classList.remove('discount-applied')
      this.discountCode = ''
      sessionStorage.removeItem('_discount_code')
      this.totalSavings = centsToDollars(this.ogTotalSavings)
      this.subtotal = centsToDollars(this.ogSubtotal)
    }
    if (code) {
      input.classList.add('input-active')
    } else {
      input.classList.remove('input-active')
    }
  }
  async _handleDiscountCode(e) {
    e.preventDefault()
    e.stopImmediatePropagation()
    this.discountLoading = true
    let code = this.shadowRoot.querySelector('.js-discount-code-form > input').value
    let res = await this._getDiscount(code)
    this._setDiscountCodeInfo(res, code)
  }

  async _getDiscount(code) {
    let url = this._getCheckout(code)
    return get(url)
  }

  _setDiscountCodeInfo(res, code = this.discountCode) {
    const parser = new DOMParser()
    const doc = parser.parseFromString(res, 'text/html')

    this.discountCodeError = false
    if (this.hasSubscription) {
      let discountAmount = doc?.querySelector('#discount_amount')?.innerText
      let discountValid = discountAmount != '' || parseInt(discountAmount) * 100 > 0 ? true : false
      if (discountValid) {
        this.discountCodeTotal = doc?.querySelector('#subtotal_amount')?.innerText
      } else {
        this.discountCodeError =
          'Discount code is not valid or only applies to one time products. Please try code on checkout page.'
      }
    } else {
      if (!doc?.querySelector('#error-for-reduction_code') && doc?.querySelector('[data-checkout-payment-due-target]'))
        this.discountCodeTotal = doc?.querySelector('[data-checkout-payment-due-target]')?.innerText ?? 0
      else {
        this.discountCodeError = 'Discount code is not valid. Please try code on checkout page.'
      }
    }
    this.discountLoading = false
    if (!this.discountCodeError) {
      this.discountCodeTotal = parseFloat(this.discountCodeTotal.replace('$', '').trim()) * 100
      this.discountCodeSavings = this.ogSubtotal - this.discountCodeTotal
      this.subtotal = centsToDollars(this.discountCodeTotal)
      this.totalSavings = centsToDollars(this.ogTotalSavings + this.discountCodeSavings)
      this.discountCode = code
      sessionStorage.setItem('_discount_code', code.toUpperCase())
    } else {
      this.subtotal = centsToDollars(this.ogSubtotal)
      this.totalSavings = centsToDollars(this.ogTotalSavings)
      this.discountCode = null
      sessionStorage.removeItem('_discount_code')
      alert(this.discountCodeError)
    }
  }

  _renderTotalSavings(totalSavings) {
    if (totalSavings > 0) {
      return html`
        <div class="flex justify-between margin-t-xs">
          <div>Total Savings</div>
          <div>-$${totalSavings}</div>
        </div>
      `
    }
  }
  _renderEvergreenPromoSavings() {
    if (this.evergreenSavings > 0 && this.hasSubscription) {
      return html`
        <div class="flex justify-between items-center" style="padding: 6px; background: #97CFF6;">
          <div class="flex items-center">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M13.2828 6.55462C13.3045 6.83665 13.2019 7.11407 13.0019 7.31409L7.27588 13.0401C6.89748 13.4185 6.28397 13.4185 5.90557 13.0401L0.998034 8.13253C0.619633 7.75413 0.619633 7.14063 0.998034 6.76223L6.72401 1.03625C6.92403 0.836231 7.20145 0.733604 7.48348 0.755299L12.1428 0.752441C12.7142 0.752441 13.2857 1.32387 13.2857 1.8953L13.2828 6.55462ZM10.9999 3.60958C11.3155 3.60958 11.5714 3.35375 11.5714 3.03816C11.5714 2.72256 11.3155 2.46673 10.9999 2.46673C10.6844 2.46673 10.4285 2.72256 10.4285 3.03816C10.4285 3.35375 10.6844 3.60958 10.9999 3.60958Z"
                stroke="#0A0A0A"
              />
            </svg>
            &nbsp;Estimated Savings with HELLONEEDED
          </div>
          <div>-$${centsToDollars(this.evergreenSavings)}</div>
        </div>
      `
    }
  }
  _renderDiscountCode() {
    if (this.discountCodeEnabled) {
      return html`
        <div
          class="flex align-center discount-code-form js-discount-code-form ${this.discountCode ? `discount-applied` : ``}"
          style="gap: 10px"
        >
          <input
            type="text"
            placeholder="Enter Coupon Code"
            value="${ifDefined(this.discountCode)}"
            @keyup=${this._discountInputHandler}
          />
          <button @click=${this._handleDiscountCode} data-loading=${this.discountLoading}>
            <span class="apply-text">Apply</span><span class="applied-text">Applied</span>
            <svg width="38" height="38" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg">
              <defs>
                <linearGradient x1="8.042%" y1="0%" x2="65.682%" y2="23.865%" id="a">
                  <stop stop-color="currentColor" stop-opacity="0" offset="0%" />
                  <stop stop-color="currentColor" stop-opacity=".631" offset="63.146%" />
                  <stop stop-color="currentColor" offset="100%" />
                </linearGradient>
              </defs>
              <g fill="none" fill-rule="evenodd">
                <g transform="translate(1 1)">
                  <path d="M36 18c0-9.94-8.06-18-18-18" id="Oval-2" stroke="url(#a)" stroke-width="2">
                    <animateTransform
                      attributeName="transform"
                      type="rotate"
                      from="0 18 18"
                      to="360 18 18"
                      dur="0.9s"
                      repeatCount="indefinite"
                    />
                  </path>
                  <circle fill="#000" cx="36" cy="18" r="1">
                    <animateTransform
                      attributeName="transform"
                      type="rotate"
                      from="0 18 18"
                      to="360 18 18"
                      dur="0.9s"
                      repeatCount="indefinite"
                    />
                  </circle>
                </g>
              </g>
            </svg>
          </button>
        </div>
      `
    }
  }

  _renderUpsells() {
    if (this.upsells?.length > 0) {
      return html`
        <div class="cart-drawer_upsells">
          <h2 class="side-cart-upsell-card-header">
            Complete your ${this.lowestFrequency > 0 ? this.lowestFrequency + ' month' : ''} routine
          </h2>
          <div class="side-cart-upsell-products-container">
            <ul class="side-cart-upsell-products">
              ${this.upsells.map((product) => {
                let price = product.price
                let comparePrice = product.compare_at_price
                if (this.lowestFrequency > 0) {
                  if (comparePrice == null && product.selling_plan_groups[0].selling_plans[0].price_adjustments[0].value) {
                    comparePrice = price
                    price =
                      price - price * (product.selling_plan_groups[0].selling_plans[0].price_adjustments[0].value / 100)
                  }

                  price = Number(centsToDollars(price / this.lowestFrequency, true))
                  comparePrice = Number(centsToDollars(comparePrice / this.lowestFrequency, true))
                } else {
                  price = Number(centsToDollars(price, true))
                }

                const sellingPlanId =
                  this.lowestFrequency >= 1 ? product.variants[0].selling_plan_allocations[0]?.selling_plan_id : null
                const upsellSellingPlanId =
                  this.lowestFrequency === 1
                    ? product?.threeMonthSellingPlanId
                    : product.variants[0].selling_plan_allocations[0]?.selling_plan_id

                return html`<li class="side-cart-upsell-card">
                  <div class="side-cart-upsell-card-image-container">
                    <img
                      src="${resizeImageSrc(product.featured_image, 500)}"
                      srcset="
                        ${resizeImageSrc(product.featured_image, 210)} 210w,
                        ${resizeImageSrc(product.featured_image, 310)} 310w,
                        ${resizeImageSrc(product.featured_image, 410)} 410w
                      "
                      sizes="(max-width: 800px) 164px, 172px"
                      alt="${product.title}"
                      loading="lazy"
                    />
                    <add-button
                      class="side-cart-upsell-card-add-button-container"
                      data-variant-id="${product.variants[0].id}"
                      data-product-handle="${product.handle}"
                      data-selling-plan-id="${sellingPlanId}"
                      disable-cart-toggle
                      data-upsell-variant-id="${product?.threeMonthVariantId}"
                      data-upsell-selling-plan-id="${upsellSellingPlanId}"
                      data-three-month-upsell-selling-plan-id="${this.lowestFrequency === 1
                        ? ''
                        : `${product?.threeMonthSellingPlanId}`}"
                      type="cart-upsell"
                    >
                      <button
                        class="btn-tertiary"
                        aria-label="Add a ${product.selling_plan_groups[0].options[1].values[0]} supply of ${product.upsell_title} to your cart for $${price.toFixed(2)}${this.lowestFrequency > 0 ? ' per month' : ''}"
                      >
                        <span aria-hidden="true">+ Add</span>
                      </button>
                    </add-button>
                  </div>
                  <div class="side-cart-upsell-card-details">
                    <div class="side-cart-upsell-card-desc-container">
                      <div class="side-cart-upsell-card-product-info-container">
                        <div class="side-cart-upsell-card-title">${product.upsell_title}</div>
                        <div class="side-cart-upsell-card-category">${product.upsell_description}</div>
                      </div>
                      <div class="side-cart-upsell-card-price-container">
                        ${comparePrice && this.lowestFrequency > 0
                          ? html` <span class="side-cart-upsell-card-compare-price">$${comparePrice}</span>`
                          : ''}
                        <span class="side-cart-upsell-card-price"
                          >$${price.toFixed(2)}${this.lowestFrequency > 0 ? '/mo' : ''}</span
                        >
                      </div>
                    </div>
                  </div>
                </li> `
              })}
            </ul>
          </div>
        </div>
      `
    }
  }

  _renderCartBottom() {
    let contShopping = ``
    if (this.main) {
      contShopping = html`
        <div class="continue-shopping">
          <a href="/"> Continue Shopping </a>
        </div>
      `
    }

    if (this.count > 0 && this.cartItems && this.cartBottomStyle == 'lines') {
      return html`
        <div class="cart-drawer_bottom">
          <div class="flex flex-col order-total cart-drawer_bottom-line-container">
            ${this.ogTotalSavings > 0
              ? html` <div class="cart-drawer_bottom-line flex justify-between">
                  <h5>Savings</h5>
                  <div>-$${this.ogTotalSavings}</div>
                </div>`
              : ''}
            ${this._renderEvergreenPromoSavings()}
            <div class="cart-drawer_bottom-line flex justify-between">
              <h5>Subtotal</h5>
              <div>$${this.subtotal}</div>
            </div>
            ${this._renderShippingText()} ${this._renderAdditionalSavingsText()}
          </div>
          <button class="btn-primary mt-3 checkout-btn" id="checkout" name="checkout" @click=${this._goToCheckout}>
            Checkout
          </button>
          ${contShopping}
        </div>
      `
    } else if (this.count > 0 && this.cartItems) {
      return html`
        <div class="cart-drawer_bottom">
          <div class="flex justify-between order-total">
            <h5 class="cart-drawer_bottom-subtotal">Subtotal</h5>
            <div class="cart-drawer_bottom-total">
              <div class="cart-drawer_bottom-savings">You save $${this.ogTotalSavings}</div>
              <div>$${this.subtotal}</div>
            </div>
          </div>
          <afterpay-placement
            data-locale="en_US"
            data-currency="USD"
            data-cbt-enabled="false"
            data-min="1"
            data-max="1000"
            data-show-upper-limit="true"
            data-show-lower-limit="false"
            data-show-if-outside-limits="true"
            data-payment-amount-is-bold="true"
            data-size="sm"
            data-logo-type="compact-badge"
            id="placement-1663711924529"
            data-amount="${this.subtotal}"
            style="margin-top: 10px; margin-bottom: 0px;"
          ></afterpay-placement>
          <button class="btn-primary mt-3 checkout-btn" id="checkout" name="checkout" @click=${this._goToCheckout}>
            Checkout
          </button>
          ${contShopping}
        </div>
      `
    }
  }

  _renderShippingText() {
    if (this.subtotal >= 75 || this.subscriptionItems.length > 0) {
      return html` <div class="cart-drawer_bottom-line flex justify-between">
        <h5>US Shipping</h5>
        <div>Free</div>
      </div>`
    }
  }

  _renderAdditionalSavingsText() {
    if (this.subscriptionItems.length > 0 && this.testOffer != 'false') {
      return html`<div class="cart-drawer_bottom-line flex justify-between additional-savings-text">
        <h5 class="text-pine">Additional First Time Savings w/ Offer</h5>
        ${this._setAdditionalSavings()}
      </div>`
    }
  }

  _setAdditionalSavings() {
    const subscriptionSubtotal = this.subscriptionItemsSubtotal
    if (this.subscriptionItemsTotalQuantity === 1) {
      const tierOneDiscount = centsToDollars(0.2 * subscriptionSubtotal)
      return html`<div class="text-pine">-$${tierOneDiscount}</div>`
    } else if (this.subscriptionItemsTotalQuantity === 2) {
      const tierTwoDiscount = centsToDollars(0.25 * subscriptionSubtotal)
      return html`<div class="text-pine">-$${tierTwoDiscount}</div>`
    } else if (this.subscriptionItemsTotalQuantity >= 3) {
      const tierThreeDiscount = centsToDollars(0.3 * subscriptionSubtotal)
      return html`<div class="text-pine">-$${tierThreeDiscount}</div>`
    }
  }

  _getCheckout(discount = this.discountCode) {
    const primaryDomain = 'thisisneeded.com'
    const isPrimaryDomain = window.location.hostname.includes(primaryDomain)
    if (!isPrimaryDomain) {
      let secondaryDomain = window.location.hostname
      let baseURL = `${primaryDomain}/cart/clear?return_to=/cart/add?`
      if (secondaryDomain === 'thisisneedednutrition.myshopify.com') {
        baseURL = `${secondaryDomain}/cart/clear?return_to=/cart/add?`
      }
      let endURL = '%26return_to=/checkout'
      const items = this.cartItems.map((item) => {
        let itemBase = `items[][id]=${item.variant_id}%26items[][quantity]=${item.quantity}%26attributes[_source_domain]=${secondaryDomain}`
        if (item.selling_plan_allocation) {
          itemBase += `%26items[][selling_plan]=${item.selling_plan_allocation.selling_plan.id}`
        }
        const properties = item.properties
          ? Object.entries(item.properties)
              .map(([key, value]) => `items[][properties][${encodeURIComponent(key)}]=${encodeURIComponent(value)}`)
              .join('%26')
          : ''
        return itemBase + (properties ? `%26${properties}` : '')
      })
      return `https://${baseURL}${items.join('%26')}${endURL}`
    }
    if (!discount) {
      return '/checkout'
    } else if (discount) {
      return '/checkout?discount=' + discount
    }
  }

  _goToCheckout() {
    if (typeof LoopOnstore !== 'undefined' && LoopOnstore.isActive() === true) {
      return
    }
    if (window?.gtag) {
      window.gtag('event', 'Side Cart - Click Checkout', {
        items: this.cartItems.map((item) => {
          return {
            id: item.id,
            name: item.title,
            category: item.type,
            variant: item.variant_title,
            list_name: 'Cart Drawer',
            quantity: item.quantity,
            price: item.price,
          }
        }),
        value: this.subtotal,
        currency: 'USD',
      })
    }
    window.location = this._getCheckout()
  }

  _renderCartBody() {
    if (typeof LoopOnstore !== 'undefined' && LoopOnstore?.isActive() === true) {
      document.querySelector('cart-drawer').shadowRoot.querySelector('.cart-drawer').classList.add('loop-active')
      LoopOnstore?.attach(document.querySelector('cart-drawer').shadowRoot.querySelector('.checkout-btn'))
    }

    if (this.main) {
      const isEmpty = this.count === 0 ? 'is-empty' : ''
      return html`
        <div class="cart-drawer_body ${isEmpty}">
          <div class="cart-drawer_products-wrap relative">
            <ul class="cart-drawer_products">
              ${this._buildCartItems()}
            </ul>
            <div class="cart-scroll-blur"></div>
          </div>
          <div class="cart-drawer_details">${this._renderCartBottom()}</div>
        </div>
      `
    } else {
      const isEmpty = this.count === 0 ? 'is-empty' : ''
      return html`
        <div class="cart-drawer_products-container">
          <div class="cart-drawer_products-line-container relative">
            <div class="loading-container">
              <img class="loading-spinner" width="50" height="50" src="${this.assets}_icon-loading-tail-spin.svg" />
            </div>
            ${this._renderLineItemContainer()}
            ${isEmpty ? this._renderEmptyCart() : ''}
            <div class="cart-drawer_upsells-container ${isEmpty}">
              ${this._renderUpsells()}
            </div>
          </div>

          </div>
          <div>${this._renderCartBottom()}</div>
        </div>
      `
    }
  }

  _renderLineItemContainer() {
    if (this.cartBuckets == true) {
      return html`<div class="cart-drawer_bucket-container">
        ${this.gwpActive == true && this.gwpThresholdMet && this.cartItems.length > 0
          ? this._renderCartLineItems([1, 3, 6, 9, 0, 'GWP'])
          : this._renderCartLineItems([1, 3, 6, 9, 0])}
      </div>`
    } else {
      return html`<div class="cart-drawer_container">
        <div class="cart-message">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="6" cy="6.0022" r="6" fill="currentColor" />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M6 3.5022C6.27614 3.5022 6.5 3.27834 6.5 3.0022C6.5 2.72605 6.27614 2.5022 6 2.5022C5.72386 2.5022 5.5 2.72605 5.5 3.0022C5.5 3.27834 5.72386 3.5022 6 3.5022ZM6.5 4.53104C6.5 4.23897 6.27614 4.0022 6 4.0022C5.72386 4.0022 5.5 4.23897 5.5 4.53104V8.97335C5.5 9.26542 5.72386 9.5022 6 9.5022C6.27614 9.5022 6.5 9.26543 6.5 8.97335V4.53104Z"
              fill="currentColor"
            />
          </svg>
          <p>You can only add 2 subscriptions of this item to your cart at a time.</p>
        </div>
        ${this._renderCartLineItems()}
      </div>`
    }
  }

  _renderEmptyCart() {
    return html`
      <div class="empty-cart">
        <p class="empty-cart_text">${this.empty_cart.text}</p>
        <div class="empty-cart_tiles-container">${this._renderCartTiles()}</div>
        <div class="empty-cart_help-card">
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M10.2051 5.9873L10.2051 12.011L15.0003 9.12969L10.2051 5.9873Z"
              fill="#0A0A0A"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M7.79492 12.0117L7.79486 5.98798L2.99974 8.86933L7.79492 12.0117Z"
              fill="#0A0A0A"
            />
          </svg>
          <span>Need some help?</span>
          <a href="${this.shop_all_url}" class="empty-cart_shop-all">SHOP ALL →</a>
        </div>
        <!-- hidden button so for loop script to attach to -->
        <button class="checkout-btn hidden" id="checkout" name="checkout">
      </div>
    `
  }

  _renderCartCount() {
    if (this.count > 0) {
      return html`<p class="cart-drawer_cart-count">(${this.count})</p>`
    }
  }

  _renderSiteWidePromotionBanner(siteWidePromotion) {
    if (siteWidePromotion.enabled) {
      switch (siteWidePromotion.cart_banner_display_rule) {
        case 'subscription':
          if (this.hasSubscription) {
            return html`<div>${siteWidePromotion.cart_heading}</div>`
          }
          break

        case 'one-time':
          if (this.hasOnetime) {
            return html`<div>${siteWidePromotion.cart_heading}</div>`
          }
          break

        default:
          return html`<div>${siteWidePromotion.cart_heading}</div>`
      }
    } else {
      return ''
    }
  }

  render() {
    return html`
      <div class="cart-drawer tailwind" loading="false" main=${this.main}>
        <div class="cart-drawer_header">
          ${(this.gift_with_purchase?.enabled && this.gwpVariantId) || this.settings.site_wide_promotion?.enabled
            ? html`<div class="gift-with-purchase_one-time-header">
                ${this._renderSiteWidePromotionBanner(this.settings.site_wide_promotion)}
                ${this.gwpThresholdMet == false &&
                this.gift_with_purchase?.enabled &&
                this.gwpVariantId &&
                this.cartItems.length > 0
                  ? html`<div>${this.gift_with_purchase.one_time_heading}</div>`
                  : ''}
              </div>`
            : ''}
          <div class="cart-drawer_header-details">
            <h3 class="cart-drawer_title">Cart</h3>
            ${this._renderCartCount()}
          </div>
          <free-shipping-progress
            free-shipping-min="75"
            free-shipping-enabled="${this.subscriptionItems.length > 0 ? 'true' : 'false'}"
            .subtotal=${this.subtotal}
            .subscriptionItemsTotalQuantity="${this.subscriptionItemsTotalQuantity}"
            .testOffer="${this.testOffer}"
          ></free-shipping-progress>
          <bundle-discount-progress
            .subscriptionItemsTotalQuantity="${this.subscriptionItemsTotalQuantity}"
            .testOffer="${this.testOffer}"
          ></bundle-discount-progress>
        </div>
        ${this._renderCartBody()}
      </div>
    `
  }

  _changeQuantity(key, quantity, currentQuantity, item) {
    if (item?.properties?._is_gift) return
    window.MicroBus.emit('cart:change-quantity', { key: key, quantity: quantity, item: item })
    if (window?.gtag) {
      if (quantity != 0 && quantity > currentQuantity) {
        window.gtag('event', 'Side Cart - Quantity Increase', {
          event_detail: item.display_title,
          event_detail2: item.variant_id,
        })
      } else if (quantity != 0 && quantity < currentQuantity) {
        window.gtag('event', 'Side Cart - Quantity Decrease', {
          event_detail: item.display_title,
          event_detail2: item.variant_id,
        })
      } else if (quantity == 0) {
        window.gtag('event', 'Side Cart - Remove Item', {
          event_detail: item.display_title,
          event_detail2: item.variant_id,
        })
      }
    }
  }
}

customElements.define('cart-drawer', CartDrawer)
